import { AppBar, Toolbar, Typography, Box, IconButton, Avatar, Tooltip, Menu, MenuItem, Divider } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import BrandSelector from './BrandSelector';
import NotificationsBell from './NotificationsBell';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Tableau de bord',
  '/strategy': 'Brand Knowledge',
  '/geo-strategy': 'GEO Strategy',
  '/audits': 'Audit Website',
  '/earned-media': 'Earned Media',
  '/brand': 'Brand Perception',
  '/social': 'Social Audit',
  '/competitors': 'Concurrents',
  '/tasks': 'Taches',
  '/settings': 'Parametres',
};

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  const pageTitle = PAGE_TITLES[location.pathname] || 'Traaker';

  return (
    <AppBar position="sticky" elevation={0} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
      <Toolbar>
        <BrandSelector />
        <Divider orientation="vertical" flexItem sx={{ mx: 2, my: 1 }} />
        <Typography variant="body1" fontWeight={500} sx={{ flexGrow: 1, color: 'text.secondary' }}>
          {pageTitle}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <NotificationsBell />
          <Tooltip title={user?.name || ''}>
            <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.75rem' }}>
                {initials}
              </Avatar>
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem disabled>
              <Typography variant="body2">{user?.email}</Typography>
            </MenuItem>
            <MenuItem onClick={logout}>
              <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
              Deconnexion
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
